import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import moment from "moment-timezone";
import "./Odds.css";
import { useSSE } from "../SSE/SSEProvider";

export function Odds() {
  const { componentEvent } = useSSE("Odds");

  const [data, setData] = useState([]);
  const [overdiff1, setOverdiff1] = useState({});
  const [backgroundColor, setBackgroundColor] = useState({});
  const API_URL = process.env.REACT_APP_DIRECT 

  useEffect(() => {
    fetch(`${API_URL}/table/today_odds`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched Data:", data); // Debugging line
        setData(data);
      })
      .catch((err) => console.log(err));
  }, [componentEvent]);

  const percentage_1 = (Home_Odds) => {
    return (100 / Home_Odds).toFixed(2);
  };

  const percentage_X = (Draw_Odds) => {
    return (100 / Draw_Odds).toFixed(2);
  };

  const percentage_2 = (Away_Odds) => {
    return (100 / Away_Odds).toFixed(2);
  };

  const totalPercentage = (Home_Odds, Draw_Odds, Away_Odds) => {
    const percent_1 = percentage_1(Home_Odds);
    const percent_X = percentage_X(Draw_Odds);
    const percent_2 = percentage_2(Away_Odds);
    return (
      parseFloat(percent_1) +
      parseFloat(percent_X) +
      parseFloat(percent_2)
    ).toFixed(2);
  };

  const calculatedOdds1 = (totalPercentage, percentage_1) => {
    const odds1 = totalPercentage / percentage_1;
    return parseFloat(odds1.toFixed(2));
  };

  const calculatedOddsx = (totalPercentage, percentage_X) => {
    const oddsX = totalPercentage / percentage_X;
    return parseFloat(oddsX.toFixed(2));
  };

  const calculatedOdds2 = (totalPercentage, percentage_2) => {
    const odds2 = totalPercentage / percentage_2;
    return parseFloat(odds2.toFixed(2));
  };

  const calculatedGap1 = (calculatedOdds1, Home_Odds) => {
    const gap1 = calculatedOdds1 - Home_Odds;
    return parseFloat(gap1.toFixed(2));
  };

  const calculatedGapx = (calculatedOddsx, Draw_Odds) => {
    const gapx = calculatedOddsx - Draw_Odds;
    return parseFloat(gapx.toFixed(2));
  };
  let callCount = 0;
  const calculatedGap2 = (calculatedOdds2, Away_Odds) => {
    callCount += 1;
    const gap2 = calculatedOdds2 - Away_Odds;
    console.log("gap2", gap2);
    console.log("Gap2 called:", callCount, "gap2:", gap2);
    return parseFloat(gap2.toFixed(2));
  };

  const calculateGreatestGap = (gap1, gapx, gap2) => {
    const greatestGap = Math.max(gap1, gapx, gap2);
    const overdiff = greatestGap - gapx;
    const overdiff1 = parseFloat(overdiff.toFixed(2));

    const result = {
      overdiff1: overdiff1,
      backgroundColor: "red",
    };

    if (greatestGap <= 0.12) {
      const tolerance = 0.0001;
      if (Math.abs(overdiff1 - 0.02) < tolerance) {
        result.backgroundColor = "#013220"; // Dark Green
      } else if (Math.abs(overdiff1 - 0.01) < tolerance) {
        result.backgroundColor = "green"; // Green
      } else if (Math.abs(overdiff1) < tolerance) {
        result.backgroundColor = "#90EE90"; // Light Green
      }
    }

    return result;
  };

  return (
    <>
      <div className="alg1_card">
        <Table striped className="Odds_table">
          <thead>
            <tr>
              <th style={{ display: "" }}>Team_code</th>
              <th> Team_A</th>
              <th> Team_B </th>
              <th>Time </th>
              <th>League </th>
              <th>1_Odds</th>
              <th>X_Odds</th>
              <th>2_Odds</th>
              <th>1</th>
              <th>X</th>
              <th>2</th>
              <th>Total_odds</th>
              <th>Gap1</th>
              <th>GapX</th>
              <th>Gap2</th>
              <th>Over2.5</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((d, i) => {
              const totalPct = totalPercentage(
                d.Home_Odds,
                d.Draw_Odds,
                d.Away_Odds
              );

              const odds1 = calculatedOdds1(
                totalPct,
                percentage_1(d.Home_Odds)
              );
              const oddsX = calculatedOddsx(
                totalPct,
                percentage_X(d.Draw_Odds)
              );
              const odds2 = calculatedOdds2(
                totalPct,
                percentage_2(d.Away_Odds)
              );

              const gap1 = calculatedGap1(odds1, d.Home_Odds);
              const gapx = calculatedGapx(oddsX, d.Draw_Odds);
              const gap2 = calculatedGap2(odds2, d.Away_Odds);

              const { overdiff1, backgroundColor } = calculateGreatestGap(
                gap1,
                gapx,
                gap2
              );

              return (
                <tr key={i} className="trname">
                  <td scope="row" className="Team_code" style={{ display: "" }}>
                    {d.Team_code}
                  </td>

                  <td scope="row" className="TeamA">
                    {d.Team_A}
                  </td>
                  <td className="TeamB">{d.Team_B}</td>
                  <td className="playing_time">
                    {moment(d.Time)
                      .tz("Africa/Nairobi")
                      .format("YYYY-MM-DD HH:mm:ss")}
                  </td>
                  <td className="league_type">{d.League}</td>
                  <td className="Home_odds">{d.Home_Odds}</td>
                  <td className="draw_odds">{d.Draw_Odds}</td>
                  <td className="away_odds">{d.Away_Odds}</td>
                  <td className="true_home">{odds1}</td>
                  <td className="true_draw">{oddsX}</td>
                  <td className="true_away">{odds2}</td>
                  <td className="total_odds">
                    {(odds1 + oddsX + odds2).toFixed(2)}
                  </td>
                  <td className="gap_1">{gap1}</td>
                  <td className="gap_x">{gapx}</td>
                  <td className="gap_2">{gap2}</td>
                  <td
                    className="over2_5"
                    style={{
                      backgroundColor,
                      color: backgroundColor ? "white" : "black",
                    }}
                  >
                    {overdiff1}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </>
  );
}
